import { useEffect, useMemo } from "react";
import { LicenseTypes } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { GridAlignment, GridColDef } from "@mui/x-data-grid-pro";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { Title } from "../../../../../../stories/Title/Title";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../../common/layout/Navbar";
import useLabels from "../../../../../../customHooks/useLabels";
import {
  GetItemsCountByJunction,
  GetSubOrSiteOrJunctionById,
} from "./queries/queries";
import {
  GetItemsCountByJunctionResult,
  GetItemsCountByJunctionVars,
  getSubOrSiteOrJunctionByIdResult,
} from "./queries/types";
import LoadingModal from "../../../../../pages/LoadingModal";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";
import { EMPTY_STRING } from "../../../../../../utils/constants";

const List = [
  {
    headerName: "Sl",
    cellClassName: "number-cell",
    field: "id",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.SLNO,
  },
  {
    headerName: `Name`,
    cellClassName: "td-link",
    field: "itemName",
    headerAlign: HEADER_TEXT_ALIGN,
    align: "",
    flex: FlexForColumns.DESCRIPTION,
    hideable: false,
  },
  {
    headerName: "Count",
    field: "count",
    headerAlign: HEADER_TEXT_ALIGN,
    align: SLNO_TEXT_ALIGN,
    flex: FlexForColumns.CODE,
  },
];

interface Props {
  NavType: LicenseTypes;
}

const JunctionItemConutList = ({ NavType }: Props) => {
  const { itemLabel } = useLabels();
  // const { customer_id, junctionID } = useUrlParams();

  const { customer_id, sub_id, company_id, siteID, junctionID, item_id } =
    useUrlParams();

  const navigate = useNavigate();

  const [getItemsCountByJunction, { data, loading }] = useLazyQuery<
    GetItemsCountByJunctionResult,
    GetItemsCountByJunctionVars
  >(GetItemsCountByJunction);

  const [getSubOrSiteOrJunctionById, { data: SubOrSiteOrJunctionData }] =
    useLazyQuery<{ node: getSubOrSiteOrJunctionByIdResult }, nodeVar>(
      GetSubOrSiteOrJunctionById,
    );
  useEffect(() => {
    const fetchSubsidiaryDetails = async () => {
      try {
        if (sub_id || siteID || junctionID) {
          getSubOrSiteOrJunctionById({
            variables: {
              id: junctionID
                ? Number(junctionID)
                : siteID
                  ? Number(siteID)
                  : sub_id
                    ? Number(sub_id)
                    : 0,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchSubsidiaryDetails();
  }, [sub_id, siteID, junctionID, getSubOrSiteOrJunctionById]);

  useEffect(() => {
    if (customer_id && junctionID) {
      getItemsCountByJunction({
        variables: {
          customerID: customer_id,
          junctionID,
        },
      });
    }
  }, [getItemsCountByJunction, customer_id, junctionID]);

  const dynamicHeaders: TableHeaderProps[] = List.map((header) => ({
    headerName: header.headerName,
    className: header.cellClassName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
  }));

  const columns: GridColDef[] = [...dynamicHeaders];

  const rows = useMemo(() => {
    if (!data) return [];

    const sorted = [...data.GetItemsCountByJunction].sort((a, b) =>
      a.itemName.localeCompare(b.itemName),
    );

    return sorted.map((node, index) => ({
      id: index + 1,
      itemID: node.itemID,
      itemName: node.itemName,
      count: node.count,
    }));
  }, [data]);

  return (
    <>
      <Navbar NavType={NavType} />
      <div className="junctions__title">
        <Title>
          {" "}
          {SubOrSiteOrJunctionData
            ? SubOrSiteOrJunctionData.node.name
            : EMPTY_STRING}{" "}
          {itemLabel} Count
        </Title>
      </div>

      <div className={`junctions`}>
        <div className="junctions__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            onCellClick={(params) => {
              if (params.field === "itemName") {
                navigate(`${params.row.itemID}/itemslist`);
              }
            }}
          />
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              mode="back"
              onClick={() => {
                navigate(-1);
              }}
            />
          </div>
          <div className="col flex-end">
            <div className="overall-total-count">
              Total Count : <b>{data && data.GetItemsCountByJunction.length}</b>
            </div>
          </div>
        </div>
      </div>
      <LoadingModal flag={loading} />
    </>
  );
};

export default JunctionItemConutList;
